<template>
    <p class="yinsi">
      <iframe :src="pageUrl" frameborder="0" class="pageFrame" :style="{height:outHeight}"></iframe>
    </p>
    <!-- <button>已阅读并同意</button> -->
</template>
<script>
let pageUrl = process.env.VUE_APP_WEBVIEW_URL + "/o2o_help_center/private.html"
export default {
  name: '',
  components:{

  },
  data () {
    return {
      pageUrl: '',
      outHeight:"300"
    }
  },
  mounted(){
    this.pageUrl = pageUrl
  },
  methods: {

  }
}
</script>
<style scoped lang='less'>
.yinsi{
  // width:272px;
  height:70vh;
  font-size:0.3467rem;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(0,0,0,0.86);
  line-height:0.4267rem;
  // overflow-y: auto;
  padding-top:0.2667rem;
  -webkit-overflow-scrolling: touch; 
  overflow-y: scroll; 
}
.pageFrame{
  width:100%;
  height:100%;
}
</style>